export default __webpack_public_path__ + "static/career-perks-1-a7f8085edbab69d08c908415c64a10e8.png";